import { useLayoutEffect, useEffect } from "react";
const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
export {
  useIsomorphicLayoutEffect as default
};
//# sourceMappingURL=use-isomorphic-layout-effect.js.map
